// extracted by mini-css-extract-plugin
export var active = "_p-8";
export var addWidgetButton = "_p-9";
export var backButton = "_p-1";
export var pageContainer = "_p-2";
export var settingsContent = "_p-0";
export var sideNavContainer = "_p-6";
export var sideNavLink = "_p-7";
export var widgetContainer = "_p-5";
export var widgetSubsectionItem = "_p-3";
export var widgetSubsectionItemContent = "_p-4";